<template>
  <div class="module toast">
    <v-snackbar v-model="toast.active" :color="toast.status" :timeout="10000" :bottom="true">
      {{ toast.text }}
      <v-btn text @click="close">
        OK
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Toast',
  computed: {
    ...mapState('app', ['toast']),
  },
  methods: {
    ...mapMutations('app', ['setToast']),
    close() {
      this.setToast({
        active: false,
        text: '',
        status: '',
      });
    },
  },
};
</script>

<style lang="scss"></style>
